import { render, staticRenderFns } from "./wf-outlined-checkbox-list-edit.vue?vue&type=template&id=845caf6a&scoped=true&"
import script from "./wf-outlined-checkbox-list-edit.vue?vue&type=script&lang=ts&"
export * from "./wf-outlined-checkbox-list-edit.vue?vue&type=script&lang=ts&"
import style0 from "./wf-outlined-checkbox-list-edit.vue?vue&type=style&index=0&id=845caf6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845caf6a",
  null
  
)

export default component.exports